<quill-editor [(ngModel)]="content" [modules]="modules" (ngModelChange)="onContentChange($event)"></quill-editor>